export default __webpack_public_path__ + "static/010a-8c0b46bca7ad79a82d69f7222223c696.jpg";